export const READING_BOOK_ENTRY_SOURCE = {
  DIRECT: "direct",
  LIST_BOOK: "list-book",
  RECENT_BOOK: "recent-book",
  TEACHING_MATERIAL: "teaching-material",
};
